import { defaultSchema } from 'rehype-sanitize';

// rehype-sanitize's default schema strips tel: hrefs, which breaks the
// clickable phone numbers assistants include in conversation messages.
const messageSanitizeSchema = {
  ...defaultSchema,
  protocols: {
    ...defaultSchema.protocols,
    href: [...(defaultSchema.protocols?.href ?? []), 'tel'],
  },
};

export default messageSanitizeSchema;
